import styled from 'styled-components';
import { TextMedium } from '../../../styles/GlobalStyledComponents';
import {
  CardColumn,
  CardInput,
  CardRow,
  CardSection,
} from '../CardsStyledComponents';

export const EditOptionText = styled(TextMedium)`
  color: ${(props) => props.theme.colors.red4};
  cursor: pointer;
`;

export const MoreOptionsLink = styled(CardInput)`
  width: 100%;
  margin: 10px 5px 25px;
  color: ${(props) => props.theme.colors.gray0};
  cursor: pointer;
`;

export const PaymentMethodRow = styled(CardRow)`
  flex-direction: row;
  margin-bottom: 0px;
`;

export const CardList = styled(CardInput)`
  max-width: 340px;
  margin: 7px 0;
  align-items: center;
`;

export const ExpirationDate = styled(TextMedium)`
  margin-left: auto;
`;

export const CardsWrapper = styled.div`
  width: 100%;
`;

export const CardInputExpress = styled(CardInput)`
  flex-wrap: wrap;
`;

export const CardColumExpress = styled(CardColumn)`
  width: calc(100% - 42px);
`;

export const CardSectionExpress = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 15px;

    @media (max-width: 350px) {
        gap: 4px;
        padding-left: 0px;
    }
`;

export const CardSectionExpressMobile = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  padding-left: 15px;
  @media (min-width: 601px) {
    display: none;
  }
`;

export const PaymentClickCardSection = styled(CardSection)`
  width: 100%;
  justify-content: space-between;
`;

export const MoreOptionsCardSection = styled(CardSection)`
    align-items: flex-end;
`;